// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__zupin","fadeIn":"styles_fadeIn__2mrQx","contentContainer":"styles_contentContainer__yOynj","heading":"styles_heading__NyIRi"};